import { FormikProps } from 'formik';
import { IMenuItem, InputFormik, SearchableDropdown } from '../../../components/Common';
import { ISettingsValues } from '../../Settings';
import { UploadImage } from '../../../components/UploadImage';
import { useTranslation } from '../../../hooks/useTranslation';

interface IMainSettingsProps<ISettingsValues> {
    context: FormikProps<ISettingsValues>;
    countries: IMenuItem[];
    currencies: IMenuItem[];
}

const MainSettings = ({ context, countries, currencies }: IMainSettingsProps<ISettingsValues>) => {
    const { t } = useTranslation();
    const { setFieldValue } = context;

    const findCountry = (countryId: string) => {
        return countries.find(country => country.value === countryId);
    };

    const findCurrency = (currencyId?: string) => {
        return currencies.find(currency => currency.value === currencyId) ?? currencies[0];
    };

    return (
        <div className="general-settings">
            <div className="general-settings__upload-container">
                <UploadImage />
            </div>
            <div className="general-settings__page-container">
                <InputFormik context={context} id="name" label={t('organizationCommon.companyName')} isRequired />
                <SearchableDropdown
                    label={t('createBranch.generalInformation.labels.contry')}
                    menuItems={countries}
                    selected={findCountry(context.values.countryId)}
                    onChange={item => {
                        setFieldValue('countryId', item.value);
                    }}
                    placeholder={t('createBranch.generalInformation.placeholders.country')}
                    isRequired
                />
                <InputFormik context={context} id="city" label={t('organizationCommon.city')} isRequired={false} />
                <InputFormik context={context} id="streetline1" label={t('labels.address1')} isRequired={false} />
                <InputFormik context={context} id="streetline2" label={t('labels.address2')} isRequired={false} />
                <InputFormik context={context} id="contact" label={t('labels.contact')} isRequired={false} />
                <InputFormik context={context} id="email" label={t('labels.email')} isRequired={false} />
                <SearchableDropdown
                    label={t('createBranch.generalInformation.labels.currency')}
                    menuItems={currencies}
                    selected={findCurrency(context.values.currencyId)}
                    onChange={item => {
                        setFieldValue('currencyId', item.value);
                    }}
                    placeholder={t('createBranch.generalInformation.placeholders.currency')}
                />
            </div>
        </div>
    );
};

export default MainSettings;
